<template>
    <section>
        <h1 class="title is-1">Editar usuario</h1>
         <b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/usuarios">Usuarios</b-breadcrumb-item>
            <b-breadcrumb-item active>Editar usuario</b-breadcrumb-item>
        </b-breadcrumb>
        <form-usuario :usuario="datosUsuario" @registrar="onEditar" v-if="datosUsuario"/>
        <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import HttpService from '../../Servicios/HttpService'
    import FormUsuario from './FormUsuario'

    export default{
        name: "EditarUsuario",
        components: { FormUsuario },

        data:()=>({
            datosUsuario: null,
            cargando: false
        }),

        async mounted(){
            this.cargando = true
            const usuario = await HttpService.obtenerConConsultas('usuarios.php', {
                accion: 'obtener_por_id',
                id: this.$route.params.id
            }) 
            this.datosUsuario = usuario
            // guardar estado original para actualizar grupos en localStorage si cambia
            this.originalGrupoId = usuario ? usuario.grupoId || null : null
            this.originalNombre = usuario ? usuario.nombre || '' : ''
            this.cargando = false
        },

        methods: {
            async onEditar(datosUsuario) {
                this.cargando = true
                const resultado = await HttpService.editar('usuarios.php',{
                    accion: 'editar',
                    usuario: datosUsuario
                })

                if (resultado) {
                    this.cargando = false
                    this.$buefy.toast.open({
                         type: 'is-info',
                         message: 'Información de usuario actualizada con éxito.'
                    })

                    // Actualizar grupos en localStorage según cambio de asignación o cambio de nombre
                    try {
                        const raw = localStorage.getItem('grupos')
                        const grupos = raw ? JSON.parse(raw) : []
                        const prevName = this.originalNombre || ''
                        const newGid = datosUsuario.grupoId || null
                        const newName = datosUsuario.nombre || ''

                        // Limpiar cualquier grupo que tuviera este usuario como jefe
                        for (let i = 0; i < grupos.length; i++) {
                            if (grupos[i].jefe === prevName) grupos[i].jefe = ''
                        }

                        // Asignar al nuevo grupo (si aplica)
                        if (newGid) {
                            const idxNew = grupos.findIndex(g => Number(g.id) === Number(newGid))
                            if (idxNew !== -1) grupos[idxNew].jefe = newName
                        }

                        localStorage.setItem('grupos', JSON.stringify(grupos))
                        window.dispatchEvent(new Event('gruposUpdated'))
                    } catch (e) {
                        console.warn('No se pudo actualizar grupos en localStorage', e)
                    }

                    this.$router.push({ name: 'UsuariosComponent'})
                } else {
                    this.cargando = false
                }
            }
        }
    }
</script>